import React, { memo } from "react";
import Wunschtermin from "./Wunschtermin";
import Baustellenadresse from "./Baustellenadresse";
import Sonstiges from "./Sonstiges";
import Rechnungsadresse from "./Rechnungsadresse";
import general from "../styles/General.module.scss";

const DynamicComponent = memo(
  ({ component, inputs, handleInputChange, inputSummary }) => {
    switch (component) {
      case "Inputs":
        return (
          <>
            {Object.keys(inputs).map((key, index) => {
              const input = inputs[key];
              const category = input["category" + index];

              if (category === "auswahl") {
                const multipleOption = input["multipleOption" + index];
                const labelValue = input["label" + index];
                const isRequired = input["required" + index] === "on";
                const [label, name] = labelValue.includes("::")
                  ? labelValue.split("::")
                  : [labelValue, labelValue];

                if (multipleOption === "einzelauswahl") {
                  return (
                    <div key={index} className={general.inputContainer}>
                      <label>
                        {label}
                        {isRequired ? <sup>*</sup> : null}
                      </label>
                      <div className="choices-container">
                        {Object.keys(input).map((subKey) => {
                          if (subKey.startsWith("option")) {
                            const optionValue = input[subKey];
                            const [optLabel, optValue] =
                              optionValue.split("::");

                            return (
                              <div key={subKey} className={general.inputRow}>
                                <input
                                  type="radio"
                                  id={input[subKey]}
                                  name={name}
                                  value={optValue || optionValue}
                                  className={`${general.radioButtons} ${
                                    isRequired ? "required" : ""
                                  }`}
                                  onChange={(e) =>
                                    handleInputChange(
                                      name,
                                      e.target.value,
                                      "radio"
                                    )
                                  }
                                  checked={
                                    inputSummary[name] === optValue ||
                                    inputSummary[name] === optionValue
                                  }
                                />
                                <label htmlFor={input[subKey]}>
                                  {optLabel || optionValue}
                                </label>
                              </div>
                            );
                          }
                          return null;
                        })}
                      </div>
                    </div>
                  );
                } else if (multipleOption === "mehrfachauswahl") {
                  return (
                    <div key={index} className={general.inputContainer}>
                      <label>
                        {label}
                        {isRequired ? <sup>*</sup> : null}
                      </label>
                      <div className="choices-container">
                        {Object.keys(input).map((subKey) => {
                          if (subKey.startsWith("option")) {
                            const optionValue = input[subKey];
                            const [optLabel, optValue] =
                              optionValue.split("::");

                            return (
                              <div key={subKey} className={general.inputRow}>
                                <input
                                  type="checkbox"
                                  id={input[subKey]}
                                  name={name}
                                  value={optValue || optionValue}
                                  className={`${general.checkboxes} ${
                                    isRequired ? "required" : ""
                                  }`}
                                  onChange={(e) =>
                                    handleInputChange(
                                      name,
                                      e.target.value,
                                      "checkbox",
                                      e.target.checked
                                    )
                                  }
                                  checked={
                                    inputSummary[name] &&
                                    inputSummary[name].includes(
                                      optValue || optionValue
                                    )
                                  }
                                />
                                <label htmlFor={input[subKey]}>
                                  {optLabel || optionValue}
                                </label>
                              </div>
                            );
                          }
                          return null;
                        })}
                      </div>
                    </div>
                  );
                }
              } else if (category === "eingabe") {
                return Object.keys(input).map((subKey) => {
                  if (subKey.startsWith("label")) {
                    const labelValue = input[subKey];
                    const isRequired = input["required" + index] === "on";
                    const [label, name] = labelValue.includes("::")
                      ? labelValue.split("::")
                      : [labelValue, labelValue];

                    return (
                      <div key={subKey} className={general.inputContainer}>
                        <label>
                          {label}
                          {isRequired ? <sup>*</sup> : null}
                        </label>
                        <input
                          type={input["type" + index]}
                          id={name}
                          name={name}
                          maxLength={input["maxCharacters" + index]}
                          max={input["maxValue" + index]}
                          min={input["minValue" + index]}
                          onChange={(e) =>
                            handleInputChange(name, e.target.value)
                          }
                          value={inputSummary[name] || ""}
                          className={`${general.mediumInput} ${
                            isRequired ? "required" : ""
                          }`}
                        />
                      </div>
                    );
                  }
                  return null;
                });
              } else if (category === "eingabe-mehrzeilig") {
                return Object.keys(input).map((subKey) => {
                  if (subKey.startsWith("label")) {
                    const labelValue = input[subKey];
                    const isRequired = input["required" + index] === "on";
                    const [label, name] = labelValue.includes("::")
                      ? labelValue.split("::")
                      : [labelValue, labelValue];

                    return (
                      <div key={subKey} className={general.inputContainer}>
                        <label>
                          {label}
                          {isRequired ? <sup>*</sup> : null}
                        </label>
                        <textarea
                          id={name}
                          name={name}
                          maxLength={input["maxCharacters" + index]}
                          onChange={(e) =>
                            handleInputChange(name, e.target.value)
                          }
                          value={inputSummary[name] || ""}
                          className={`${general.largeInput} ${
                            isRequired ? "required" : ""
                          }`}
                        />
                      </div>
                    );
                  }
                  return null;
                });
              } else if (category === "upload") {
                const labelValue = input["label" + index];
                const isRequired = input["required" + index] === "on";
                const [label, name] = labelValue.includes("::")
                  ? labelValue.split("::")
                  : [labelValue, labelValue];
                const dataType = input["dataType" + index];
                let accept;
                if (dataType === "pdf") {
                  accept = ".pdf";
                } else if (dataType === "image") {
                  accept = "image/*";
                } else if (dataType === "doc") {
                  accept = ".doc, .docx, .pdf"; // Include common document types
                }

                return (
                  <div key={index} className={general.inputContainer}>
                    <label>
                      {label}
                      {isRequired ? <sup>*</sup> : null}
                    </label>
                    <input
                      type="file"
                      id={name}
                      name={name}
                      accept={accept}
                      size={input["maxSize" + index] * 1048576}
                      className={isRequired ? "required" : ""}
                      onChange={(e) =>
                        handleInputChange(name, e.target.files[0], "file")
                      }
                    />
                  </div>
                );
              }
              return null;
            })}
          </>
        );
      case "Wunschtermin":
        return (
          <Wunschtermin
            handleInputChange={handleInputChange}
            inputSummary={inputSummary}
          />
        );
      case "Baustellenadresse":
        return (
          <Baustellenadresse
            handleInputChange={handleInputChange}
            inputSummary={inputSummary}
          />
        );
      case "Sonstiges":
        return (
          <Sonstiges
            handleInputChange={handleInputChange}
            inputSummary={inputSummary}
          />
        );
      case "Rechnungsadresse":
        return (
          <Rechnungsadresse
            handleInputChange={handleInputChange}
            inputSummary={inputSummary}
          />
        );
      default:
        return null;
    }
  }
);

export default DynamicComponent;
